import { createClient } from '@supabase/supabase-js';

const SUPABASE_URL = 'https://llpfepxcqsjfsxvmqpjo.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxscGZlcHhjcXNqZnN4dm1xcGpvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzYwOTg3MjAsImV4cCI6MjA5MTY3NDcyMH0._JXmdLxAaD_yckUFcqnYJkCDkbcY4hu3LHJfTW5PhBA';

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    storage: localStorage,
    persistSession: true,
    autoRefreshToken: true,
  },
});
